import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import {
  Container, Row, Col, Card, CardBody, Spinner
} from "reactstrap";
import { Link } from "react-router-dom"

//Import Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import WelcomeComp from "./WelcomeComp";
import classNames from "classnames";
// import StackedColumnChart from "./StackedColumnChart";
import { useSelector, useDispatch } from "react-redux";
import { getAdminRoles, getAllQuotes, getChartsData as onGetChartsData, getClients, getCounts } from "../../store/actions";
import PieChart from "./charts/PieChart";
import BarChart from "./charts/BarChart";
import UsersCount from "./components/UsersCount";
import RecentQuotes from "./components/RecentQuotes";
import super_admins from '../../assets/images/svg/dashboard/super-admins.svg'
import admins from '../../assets/images/svg/dashboard/total-admins.svg'
import bookings from '../../assets/images/svg/dashboard/total-booking.svg'
import clients from '../../assets/images/svg/dashboard/total-clients.svg'
import enquiries from '../../assets/images/svg/dashboard/total-enquiries.svg'
import users from '../../assets/images/svg/dashboard/total-users.svg'
import Skeleton from "react-loading-skeleton"; 
import { ErrorRequest } from "store/errorscreen/actions";
//redux

const Dashboard = props => {
  const [periodData, setPeriodData] = useState();
  const { totalCounts, loader } = useSelector(state => ({
    totalCounts: state.GetCounts.Counts.data,
    loader: state.GetCounts.loader
  }))
  const [access, setAccess] = useState({})
  const [role, setRole] = useState()
  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    setRole(obj?.user?.role)
  }, [role])  
  useEffect(() => {
    if (role === 'ADMIN') {
      setAccess({
        clients: true,
        users: true,
        admins: false,
        superAdmins: false
      })
    } else if (role === 'SUPER_ADMIN') {
      setAccess({
        clients: true,
        users: true,
        admins: true,
        superAdmins: true
      })
    } else if (role === 'CLIENT') {
      setAccess({
        clients: false,
        users: false,
        admins: false,
        superAdmins: false
      })
    }
  }, [role])

  const reports = [
    {
      title: "Total Booking",
      iconClass: bookings,
      total: totalCounts?.totalBookings ? totalCounts?.totalBookings : 0,
      access: true
    },
    {
      title: "Total Enquiries",
      iconClass: enquiries,
      total: totalCounts?.totalquotes ? totalCounts?.totalquotes : 0,
      access: true
    },
    {
      title: "Total Clients",
      iconClass: clients,
      total: totalCounts?.totalClients ? totalCounts?.totalClients : 0,
      access: access.clients
    },
    {
      title: "Total Super Admins",
      iconClass: super_admins,
      total: totalCounts?.totalSuperAdmins ? totalCounts?.totalSuperAdmins : 0,
      access: access.superAdmins
    },
    {
      title: "Total Admins",
      iconClass: admins,
      total: totalCounts?.totalAdmins ? totalCounts?.totalAdmins : 0,
      access: access.admins
    },
    {
      title: "Total Users",
      iconClass: users,
      total: totalCounts?.totalUsers ? totalCounts?.totalUsers : 0,
      access: access.users
    },
  ];
  const { chartsData } = useSelector(state => ({
    chartsData: state.Dashboard.chartsData
  }));

  useEffect(() => {
    setPeriodData(chartsData);
  }, [chartsData]);

  const dispatch = useDispatch();
  // useEffect(() => {
  //   // dispatch(onGetChartsData("yearly"));
  // }, []);
  useEffect(() => {
    dispatch(getCounts())
  }, [])
 
  //meta title
  document.title = "Dashboard | Glottis Logistics"; 
  return (
    <React.Fragment>
      <div className="page-content dashbord">
        <Container fluid>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between"><h4 className="mb-sm-0 font-size-18">Dashboard</h4><div className="page-title-right"></div></div>
          <Row>
            <Col xl="4">
              <WelcomeComp />

            </Col>
            <Col xl="8" className="list-details">
              <Row>
                {/* Reports Render */}
                {reports?.map((report, key) => (
                  report.access &&
                  < Col md="4" key={"_col_" + key} >
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            {loader? <Skeleton height={"24px"} width={'80px'} />:
                            <h4 className="mb-0">{report.total}</h4>}
                          </div>
                          <div className="icon avatar-sm rounded-circle align-self-center mini-stat-icon">
                            <span className="icon avatar-title rounded-circle ">
                              <img src={report.iconClass} alt={report.title} />
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xl="4">
              <Card className="mini-stats-wid">
                <CardBody className="piechart">
                  <PieChart />
                </CardBody>
              </Card>
            </Col>
            <Col xl="8" className="list-details">
              <Card>
                <CardBody className="barchat">
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">Bookings</h4>
                    <div className="ms-auto">
                      <ul className="nav nav-pills">
                        <li className="nav-item">
                          <Link
                            to="#"
                            className={'active nav-link'}
                            id="one_month"
                          >
                            Last six month
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <div className="clearfix"></div> */}
                  {/* <StackedColumnChart periodData={periodData} dataColors='["--bs-primary", "--bs-warning", "--bs-success"]' /> */}
                  <BarChart />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl="12">
              <RecentQuotes />
            </Col>
            {/* <Col xl="6">
              <UsersCount />
            </Col> */}
          </Row>
        </Container>
      </div >
    </React.Fragment >
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
